import { defineIdentity } from '../featureModule'

/**
 * The composed platform surface: deliberately un-licensed lanes that migrated
 * feature frontends (and machine/webhook callers) consume. `entitlements: null`
 * is the platform discriminant — every registration carries entitlement: null
 * and a reason. Platform owns auth/db/http/encryption/logging/webpush plus the
 * decided-free platform surfaces (health, setup state, feature-flags, vanity,
 * vpc-test, platform-observability, dashboard aggregates, notifications,
 * mcp-credentials, licensing/entitlements, impersonation); it owns no feature
 * tables and imports no feature modules (design 5.2, §7).
 */
export const identity = defineIdentity({ name: 'platform', entitlements: null })
